import { policiesService } from '@/services/policies.service'
import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import PageLoader from '../Shared/PageLoader'

// Maps the backend's defaultService value (see pickDefaultService) to a route in this app.
export const DEFAULT_SERVICE_ROUTES: Record<string, string> = {
  'factor-analytics': '/factor-analytics',
  reports: '/reports',
  'what-if-analysis': '/what-if-analysis',
  'scenario-builder': '/scenario-builder',
  'portfolio-optimization': '/portfolio-optimization',
}
export const FALLBACK_ROUTE = '/reports'

// Rendered for any URL that doesn't match a known route; redirects to the user's
// recommended landing service instead of always assuming /reports.
export const DefaultServiceRedirect = () => {
  const [target, setTarget] = useState<string | null>(null)

  useEffect(() => {
    policiesService
      .getPolicies()
      .then(({ defaultService }) => setTarget(DEFAULT_SERVICE_ROUTES[defaultService ?? ''] ?? FALLBACK_ROUTE))
      .catch(() => setTarget(FALLBACK_ROUTE))
  }, [])

  if (!target) return <PageLoader />
  return <Navigate to={target} replace />
}
